module.exports = __webpack_public_path__ + "assets/popup_close.f0171878fd44d36429cf11ae05299c69.svg";